import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';
import C from 'utils/values/constant.util';

import CN from './ModalSetupOnlineBooking.module.scss';

const BOOKING_STEPS = C([
  {
    number: 1,
    textTranslateKey: 'onlineBooking.generalSettings.onlineBookingModal.step1',
  },
  {
    number: 2,
    textTranslateKey: 'onlineBooking.generalSettings.onlineBookingModal.step2',
  },
  {
    number: 3,
    textTranslateKey: 'onlineBooking.generalSettings.onlineBookingModal.step3',
  },
]);

const ModalSetupOnlineBooking = ({ isOpen, onClick, onClose }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="ModalSetupOnlineBooking-modal" isOpen={isOpen}>
      <SalonModal.Header>
        <div className={CN.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={CN.modalImage}>
          <div className={CN.iconContainer}>
            <Icon variant="settings" width="lg" selected />
          </div>
        </div>
        <div className={CN.modalContent}>
          <div className={CN.modalTitle}>{t('onlineBooking.generalSettings.onlineBookingModal.title')}</div>
          <div className={CN.modalSubTitle}>{t('onlineBooking.generalSettings.onlineBookingModal.description')}</div>
          <div className={CN.modalText}>
            {BOOKING_STEPS.map((step) => (
              <div className={CN.item}>
                <div className={CN.number}>{step.number}</div>
                {t(step.textTranslateKey)}
              </div>
            ))}
          </div>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="primaryForce" onClick={onClick}>
          <span className={CN.buttonSpace}>{t('onlineBooking.generalSettings.onlineBookingModal.confirmation')}</span>
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};

export default ModalSetupOnlineBooking;
